// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.inputs > *[data-v-42503575]:not(:last-child) {\n\tmargin-bottom: 10px;\n}\n.download-link[data-v-42503575]{\n\tmargin: 5px 10px;\n\tfont-size:1.1em;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
